import { cva } from 'class-variance-authority';

export const wrapperClasses = cva([
  'py-0-5 flex w-fit flex-row items-center gap-1 rounded-full px-2'
]);
